import React, { useState } from "react";
import styled from "styled-components";
import Colors from "../../../styles/Colors";
import Button from "../../../components/Button";
import { H4 } from "../../../styles/Fonts";
import CustomModal from "../../../components/Modal";
import { getTruncNum } from "../../../utils/common";
import { useWeb3React } from "@web3-react/core";
import { depositTokenIntoBalanceVault } from "../../../utils/api/balanceVaultApi";
import AmountInput from "../../../components/AmountInput";
import { CHAIN_IDS_TO_NAMES } from "../../../utils/constant/chains";

type Props = {
  isShowModal: boolean;
  setShowModal: (v: boolean) => void;
  setIsDepositing: (v: boolean) => void;
  updateBalances: () => void;
  currency: string;
  tokenAddress: string;
  tokenDecimal: number;
  tokenBalance: number;
  deployedChainId: number;
  setBridgeModalIsShow: () => void;
};

const DepositModal: React.FC<Props> = (props) => {
  const {
    isShowModal,
    setShowModal,
    setIsDepositing,
    updateBalances,
    currency,
    tokenAddress,
    tokenDecimal,
    tokenBalance,
    deployedChainId,
    setBridgeModalIsShow,
  } = props;

  const { account, chainId, library } = useWeb3React();

  const [amount, setAmount] = useState<number>(0);

  const handleOnDeposit = async () => {
    if (
      account &&
      amount &&
      chainId &&
      tokenAddress &&
      tokenDecimal &&
      library
    ) {
      setShowModal(false);
      setAmount(0);
      setIsDepositing(true);

      await depositTokenIntoBalanceVault(
        account,
        tokenAddress,
        tokenDecimal,
        amount,
        chainId,
        library
      );

      updateBalances();
      setIsDepositing(false);
    }
  };

  return (
    <CustomModal
      show={isShowModal}
      onHide={() => setShowModal(false)}
      title={`Deposit ${currency}`}
    >
      <AmountInput
        setAmount={setAmount}
        tokenSymbol={currency}
        tokenDecimal={tokenDecimal}
        showMaxBtn={true}
        maxAmount={tokenBalance}
      />
      <InfoContainer>
        <BalanceRow>
          <Label>Wallet Balance</Label>
          <Value>
            {getTruncNum(tokenBalance, tokenDecimal)} {currency}
          </Value>
        </BalanceRow>
      </InfoContainer>
      <BtnContainer>
        <Button
          btnType="primary"
          btnText="Deposit"
          onClick={handleOnDeposit}
          disabled={!amount}
          isLoading={false}
        />

        <BridgeBtn
          onClick={setBridgeModalIsShow}
        >{`Bridge Your Asset to ${CHAIN_IDS_TO_NAMES[deployedChainId]}`}</BridgeBtn>
      </BtnContainer>
    </CustomModal>
  );
};

export default DepositModal;

const InfoContainer = styled.div`
  margin-top: 20px;
`;

const Label = styled(H4)`
  color: ${Colors.gray3};
  font-size: 13px;
  line-height: 22px;
`;

const Value = styled.span`
  margin: 0;
  font-size: 14px;
  line-height: 28px;
  font-weight: bold;
  color: ${Colors.ivory};
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

const BalanceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
`;

const BtnContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  button:first-child {
    border-radius: 4px;
    font-size: 16px;
    line-height: 22px;
  }
`;

const BridgeBtn = styled.button`
  width: 100%;
  padding: 4px 12px;
  border: 1px solid ${Colors.ivory};
  border-radius: 100px;
  font-size: 13px;
  line-height: 22px;
  color: ${Colors.ivory};
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  :hover {
    border: 1px solid ${Colors.lightKhaki};
    color: ${Colors.lightKhaki};
  }
  :active {
    transform: scale(0.99);
  }
`;
